module.exports = __webpack_public_path__ + "static/flux-ab-testing-970e57196fefa959ac416240e671061e.jpg";